import React, { useState } from "react";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";
import nodeinstance from "../../../../../nodeInstance";
import UploadFilePopUp from "../../../../../ReusableComponents/UploadFile/uplaodFile";
import DocumentUploadFilePopUp from "../../Iqama/FileDocumentPopUp/FileDocumentPopUp";
import { IoIosSave } from "react-icons/io";
import BankDetailsUpdate from "./BankDetailsUpdate";
import DocumentUploadFilePopUp_Physical from "./UploadPopUp";
import UploadFilePopUp_New from "../../../../../ReusableComponents/UploadFile/UploadFileNew";

export default function ListPhysicalCardDetailsUpdate({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  console.log(list?.data);
  const [Popup, setPopUp] = useState(false);
  const [PopupDoc, setPopUpDoc] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const dispatch = useDispatch();

  const [item, setItem] = useState(() => {
    if (Array.isArray(list.data)) {
      return list.data.filter((e) => e.atm_status_value === 4);
    }
    return []; // Fallback if list.data is not an array
  });

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list?.data || []);

  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(`/atm-payroll/downloadCard`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Physical_Card`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const updateBankDetail = async (type) => {
    console.log("type", type);
    try {
      const res = await nodeinstance.post(
        `/atm-payroll/updateBankDetail`,
        type,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log(res);
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        updateData("");
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error?.response?.data.error,
        })
      );
    }
  };

  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => setPopUpDoc(true)}
          disabled={downloadLoading || list?.isLoading}
        >
          <p>Upload document</p>
          {downloadLoading && <CgSpinner className="animate-spin" />}
        </button>
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => setPopUp(true)}
        >
          <p>Upload List</p>
          {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
        </button>
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => downloadFile()}
          disabled={downloadLoading || list?.isLoading}
        >
          <p>Download</p>
          {downloadLoading && <CgSpinner className="animate-spin" />}
        </button>
        <Search
          searchKey={["employee_id", "visa_reference_number", "border_number"]}
          setSearchWords={setSearchWords}
        />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 bg-white min-w-[3120px]">
            <div className="grid grid-cols-table-atm-physical-card gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div>
            {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading &&
              currentList.map((list, index) => (
                <div
                  key={index}
                  className={`grid grid-cols-table-atm-physical-card gap-5 p-6 text-center ${list.status_number === 1 ? "bg-yellow-300 " : list.status_number === 2 ? "bg-red text-white" : "bg-white"} 3 m-2 p-6 min-w-[3120px]`}
                >
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_expiry_date_g || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_expiry_date_h || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.mobile_number || "-"}
                      />
                    </p>
                    {/* ACCOUNT TO BE OPENED BY */}
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.payroll_category || "-"}
                      />
                    </p>
                    {/* FEES */}
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.fees || "-"}
                      />
                    </p>
                    {/* PAYMENT STATUS */}
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.payment_status || "-"}
                      />
                    </p>
                    {/* bank name  */}

                    <BankDetailsUpdate
                      value={list.bank_name}
                      index={index}
                      placeholder={"Bank NAME"}
                      updateBankDetail={(e) =>
                        updateBankDetail({
                          employee_id: list.employee_id,
                          bank_name: e.accountNumber,
                          account_number: list.account_number,
                          iban_number: list.iban_number,
                          atm_card_number: list.atm_card_number,
                          atm_card_expiry: list.atm_card_expiry,
                        })
                      }
                    />

                    {/* account_number */}

                    <BankDetailsUpdate
                      value={list.account_number}
                      index={index}
                      placeholder={"account number"}
                      updateBankDetail={(e) =>
                        updateBankDetail({
                          employee_id: list.employee_id,
                          bank_name: list.bank_name,
                          account_number: e.accountNumber,
                          iban_number: list.iban_number,
                          atm_card_number: list.atm_card_number,
                          atm_card_expiry: list.atm_card_expiry,
                        })
                      }
                    />

                    {/* IBAN NUMBER */}

                    <BankDetailsUpdate
                      value={list.iban_number}
                      index={index}
                      placeholder={"iban number"}
                      updateBankDetail={(e) =>
                        updateBankDetail({
                          employee_id: list.employee_id,
                          bank_name: list.bank_name,
                          account_number: list.account_number,
                          iban_number: e.accountNumber,
                          atm_card_number: list.atm_card_number,
                          atm_card_expiry: list.atm_card_expiry,
                        })
                      }
                    />

                    {/* ATM CARD NUMBER */}
                    <BankDetailsUpdate
                      value={list.atm_card_number}
                      index={index}
                      placeholder={"atm Number"}
                      updateBankDetail={(e) =>
                        updateBankDetail({
                          employee_id: list.employee_id,
                          bank_name: list.bank_name,
                          account_number: list.account_number,
                          iban_number: list.iban_number,
                          atm_card_number: e.accountNumber,
                          atm_card_expiry: list.atm_card_expiry,
                        })
                      }
                    />
                    {/* ATM CARD ex */}
                    <BankDetailsUpdate
                      value={list.atm_card_expiry}
                      index={index}
                      placeholder={"atm card expiry"}
                      updateBankDetail={(e) =>
                        updateBankDetail({
                          employee_id: list.employee_id,
                          bank_name: list.bank_name,
                          account_number: list.account_number,
                          iban_number: list.iban_number,
                          atm_card_number: list.atm_card_number,
                          atm_card_expiry: e.accountNumber,
                        })
                      }
                    />

                 

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={
                          list?.physical_atm_card_applied_date || "-"
                        }
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={
                          list.physical_atm_card_recived_date || "-"
                        }
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.physical_card_status || "-"}
                      />
                    </p>
                    {/* <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    /> */}
                  </React.Fragment>
                </div>
              ))}
          </div>
        </div>
      </div>
      <Pagination />
      {Popup ? (
        <UploadFilePopUp_New
          PopUp={Popup}
          setPopUp={setPopUp}
          title={"Upload Physical Card Details"}
          url={"/atm-payroll/uploadCard"}
          callBack={updateData}
        />
      ) : (
        ""
      )}
      {PopupDoc ? (
        <DocumentUploadFilePopUp_Physical
          PopUp={PopupDoc}
          setPopUp={setPopUpDoc}
          title={"Bulk Upload Documents"}
          url={`/atm-payroll/bulkuploadDoc/`}
          callBack={updateData}
          fileFormat={">  ATM-PAYROLL-CARD-EMPLOYEEID"}
          fileNme={"ATM-PAYROLL-CARD-EMPLOYEEID"}
        />
      ) : (
        ""
      )}
    </>
  );
}
